import SingleSelect from '@mailstep/design-system/ui/Elements/SingleSelect/SingleSelect'
import withFormikToProps from '@utils/formik/withFormikToProps'

export default withFormikToProps(SingleSelect)
